import React from "react";

import Header from "@components/Header";
import Footer from "@components/Footer";
import useBodyClass from "@utils/useBodyClass";
import { useRecordCurrentLocation } from "../../utils/navigation";
import { LayoutProps } from "./index.interface";
import { useCurrentSettings } from "../PersistedData/settingsSlice";

/* eslint react-hooks/rules-of-hooks: "warn" */

const Layout = ({ children, includeFooter, recordLocation }: LayoutProps) => {
  const settings = useCurrentSettings();
  useBodyClass(`mode-${settings.mode}`, "mode-noscript");
  if (recordLocation) {
    useRecordCurrentLocation();
  }

  return (
    <>
      <Header />
      {children}
      {includeFooter && <Footer />}
    </>
  );
};

export default Layout;
